import React from "react";
import doc6 from "../assets/img/doctor/anjana.jpg";
import { useLocation, Link } from "react-router-dom";
import CustomTitle from "../CustomTitle";

export default function Anjana() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const helmetDescriptions = {
    titleName: "",
    Description: "",
  };

  return (
    <div id="each-doctor">
      <CustomTitle customValue={helmetDescriptions} />
      {/* <div className="py-md-5" style={{ backgroundImage: "url(" + blogHeader + ")", backgroundPosition: 'center', backgroundSize: 'cover', height: '400px' }}>
        <div className="banner-header text-center py-5">
            <h2 style={{ color: '#fff', position: "relative", top: "100px" }}>Dr. DIVYASREE D</h2>
        </div>
    </div> */}
      <br />
      {/* <h6 className="offset-1 my-4 "  style={{ textAlign: "left", color: "black" }}>HOME &gt; MEDIA &gt; Blog</h6> */}
      <nav aria-label="breadcrumb" id="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>

          <li className="breadcrumb-item active" aria-current="page">
            Doctor
          </li>
        </ol>
      </nav>
      {/* -------------------------doctor detail--------------- */}

      <div className="container mt-4">
        <div className="row">
          <div className="col-md-5">
            <div className="card" style={{ maxWidth: "30rem" }}>
              <img src={doc6} className="card-img-top" alt="Dr. Anjana " />
            </div>
            <br />
            <br />
            <br />
            <h3>More Info</h3>
            <br />
            <p>MBBS, MD</p>
            <br />
            <p>
              Department : <span>Physician</span>
            </p>
            <br />
            {/* <p>Consultations : 15 Minutes per Consultation</p>
            <br /> */}
            <p>Location : Bangalore</p>
            <br />

            <span className="badge bg-primary p-2">
              Available on Prior Appointment
            </span>
            <br />
            <p> -Toll-free number @ 1800-425-4500</p>
            <br />
          </div>
          <div className="col-md-7">
            <h1 className="text-blue">DR. ANJANA CHERAL</h1>
            <p>
              <strong>PHYSICIAN</strong>
            </p>
            <h3>PROFILE:</h3>

            <span>
              Consultant Physician with over 2 years of experience in General
              and Emergency Medicine.
            </span>
            <br />

            <br />
            <h3>QUALIFICATION</h3>

            <span>
              <ol>
                <li>
                  M.D. General Medicine (May 2022) ESIC MC PGIMSR – RNR,
                  affiliated to Rajiv Gandhi University of Health and Sciences,
                  Bengaluru, Karnataka, India.
                </li>
                <li>
                  M.B.B.S. (March 2018) - Raja Rajeswari Medical College and
                  Hospital, Kumbalgodu, affiliated to Rajiv Gandhi University of
                  Health and Sciences, Bengaluru, Karnataka, India.
                </li>
                <li>
                  Topper of the College in 3 subjects – E.N.T., General Surgery,
                  and Paediatrics.
                </li>
              </ol>
            </span>
            <br />
            <br />
            <h3>WORK EXPERIENCE</h3>

            <span>
              <ol>
                <li>
                  Senior Resident, ESIC Medical College, Rajaji Nagar (July 2022
                  - July 2024)Specialized in General and Emergency Medicine.
                  Managed Outpatient Department (OPD), In-Patients, and handled
                  Casualties and Emergencies.
                </li>
                <li>
                  Consultant Physician, Suguna Hospital, Rajaji Nagar
                  Independently managed admissions and oversaw OPD services.
                </li>
                <li>
                  Consultant Physician, Kangaroo Care, Vijaya Nagar
                  Independently managed admissions and oversaw OPD services.
                </li>
              </ol>
            </span>
            <br />
            <br />

            <h3>Professional Memberships:</h3>
            <span>
              <ol>
                <li>
                  Karnataka Medical Council (KMC) Registration No.: 123380
                </li>
              </ol>
            </span>

            <br />
            <br />

            {/* <ol></ol> */}
            {/* <p>
              Dr. Divyasree is practicing obstetrician and gynecologist with
              experience of more than 10 yrs and exclusive experience in
              treating infertile couple for the past 3 years.
            </p>
            <p>
              She completed her MBBS from prestigious Gandhi medical college,
              Hyderabad and did her post graduation in Obstetrics and Gynecology
              from CAIMS Karimnagar, Andra Pradesh. She has done her fellowship
              in reproductive medicine from CRAFTS hospital and research
              institute, Kerala. She is trained in minimal invasive surgeries,
              at Bangalore.
            </p>
            <p>
              Dr. Divyasree is specialized in treating infertile couple with
              PCOS, poor ovarian reserve, recurrent IVF failures and recurrent
              pregnancy loss.
            </p>
            <p>
              She has given good pregnancy rates and take home baby rate in
              infertile couple
            </p>
            <h3>QUALIFICATION</h3>
            <p>MBBS, MS (OBG)</p>
            <p>Fellowship in reproductive medicine</p>
            <h3>WORK EXPERIENCE</h3>
            <p>
              Consultant at Garbhagudi IVF center, Bangalore from 2018 till
              2021.
            </p>
            <p>
              Reproductive medicine unit at CRAFTS hospital, Kerala 2017 t0
              2018.
            </p>
            <p>
              Assistant professor in dept of OBG at PESIMSR, Kuppam.2012 to
              2017.
            </p>
            <h3>RESEARCH AND PUBLICATIONS:</h3>
            <p>
              She has presented and published various clinical papers and case
              reports in national journals and conferences.
            </p>
            <p>
              Testicular sperms versus macs in patients with high dna
              fragmentation index and their ICSI outcome - presentation at
              national fertility conference 2018.
            </p>
            <p>
              Laparoscopic management of large ovarian cyst – published in
              international journal Reprod contracept Obstet Gynecol 2017.
            </p>
            <p>
              Disengagement of the deeply engaged fetal head during caesarean
              section in advanced labour : patwardhan versus push method
              published in international journal reprod contracept obstet
              gynecol 2015.
            </p>
            <h3>MEMBERSHIP:</h3>
            <p>Karnataka Medical Council</p>
            <p>She is a life time member in Indian fertility society.</p> */}
          </div>
        </div>
      </div>
    </div>
  );
}
